import { useState } from 'react'

import AnimateHeightAndOpacity from './AnimateHeightAndOpacity'
import EmployerNotes, { type EmployerNotesProps } from './EmployerNotes'
import RotatingCircleRightChevron from './RotatingCircleRightChevron'

const AdminEmployerNotes = (props: EmployerNotesProps) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <div className='p-4 rounded-md border bg-white shadow-sm'>
      <div className='flex justify-between items-center cursor-pointer' onClick={() => setIsOpen((prev) => !prev)}>
        <h3 className='text-2xl font-bold text-gray-900'>Employer Notes</h3>
        <RotatingCircleRightChevron isOpen={isOpen} />
      </div>
      <AnimateHeightAndOpacity isOpen={isOpen}>
        <div className='pt-6 pb-2'>
          <EmployerNotes {...props} />
        </div>
      </AnimateHeightAndOpacity>
    </div>
  )
}

export default AdminEmployerNotes
